export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';
export const USER_IS_AUTHENTICATED = 'USER_IS_AUTHENTICATED';
export const USER_IS_AUTHENTICATED_IS_LOADING =
  'USER_IS_AUTHENTICATED_IS_LOADING';
export const NETWORK_ERROR = 'NETWORK_ERROR';

export const SET_NETWORK_ERROR_NOTIFICATION = 'SET_NETWORK_ERROR_NOTIFICATION';
export const REMOVE_NETWORK_ERROR_NOTIFICATION =
  'REMOVE_NETWORK_ERROR_NOTIFICATION';

// desktop Table
export const SELECT_FILTER = 'SELECT_FILTER';
export const TOGGLE_TABLE_MAP_VIEW = 'TOGGLE_TABLE_MAP_VIEW';
export const SWAP_SELECTED_POINT = 'SWAP_SELECTED_POINT';
export const SET_SELECTED_FROM = 'SET_SELECTED_FROM';
export const SET_SELECTED_TO = 'SET_SELECTED_TO';
export const SET_SELECTED_ROUTE = 'SET_SELECTED_ROUTE';
export const SET_SELECTED_DATE_TIME = 'SET_SELECTED_DATE_TIME';
export const SET_SAFETY_MARGIN = 'SET_SAFETY_MARGIN';

// desktop Map
export const TOGGLE_WARNINGS_ON_MAP = 'TOGGLE_WARNINGS_ON_MAP';
export const TOGGLE_MORE_OPTIONS = 'TOGGLE_MORE_OPTIONS';
export const OPEN_MORE_OPTIONS = 'OPEN_MORE_OPTIONS';
export const CLOSE_MORE_OPTIONS = 'CLOSE_MORE_OPTIONS';
export const SET_VIEW_STATE = 'SET_VIEW_STATE';
export const SET_LAYER_STYLE = 'SET_LAYER_STYLE';
export const SET_DRAFT = 'SET_DRAFT';
export const SET_VIEW_LOCK = 'SET_VIEW_LOCK';

// map and table modals
export const OPEN_MODAL_ITEM = 'OPEN_MODAL_ITEM';
export const CLOSE_MODAL_ITEM = 'CLOSE_MODAL_ITEM';
export const SET_MODAL_ITEM = 'SET_MODAL_ITEM';

// ships
export const SET_SELECTED_SHIP = 'SET_SELECTED_SHIP';

// performances
export const SET_LOGBOOK_SELECTOR = 'SET_LOGBOOK_SELECTOR';
export const SET_LOGBOOK_FILTER = 'SET_LOGBOOK_FILTER';

export const SET_REFERENCE_ID = 'SET_REFERENCE_ID';
export const RESET_REFERENCE_ID = 'RESET_REFERENCE_ID';
export const UPDATE_UKC_THRESHOLD = 'UPDATE_UKC_THRESHOLD';
